import { useEffect, useRef, useState } from 'react'
import { InputBase } from '@mui/material'
import type { PropertyInputProps } from '@/objects/property-forms/PropertyInputProps.tsx'
import { ClickableArea } from '@/objects/property-forms/ClickableArea.tsx'

export type TextPropertyInputProps = PropertyInputProps<string> & { hidePlaceholder?: boolean }

export function TextPropertyInput({ value, onValueChange, hidePlaceholder }: TextPropertyInputProps) {
  const [local, setLocal] = useState(value)
  const [focused, setFocused] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    setLocal(value)
  }, [value])

  function commit() {
    if (local !== value) onValueChange(local)
  }

  const showEmptyDash = hidePlaceholder && !value && !focused

  return (
    <ClickableArea onClick={() => inputRef.current?.focus()}>
      <div style={{ position: 'relative', width: '100%' }}>
        {showEmptyDash && (
          <span
            style={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              color: 'var(--mui-palette-text-disabled)',
              fontSize: 13,
              pointerEvents: 'none',
            }}
          >
            —
          </span>
        )}
        <InputBase
        inputRef={inputRef}
        value={local}
        onChange={(e) => setLocal(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => { setFocused(false); commit() }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') (e.target as HTMLInputElement).blur()
        }}
        placeholder={hidePlaceholder ? undefined : 'Lorem Ipsum'}
        sx={{ fontSize: 13, width: '100%', p: 0, color: showEmptyDash ? 'transparent' : undefined }}
      />
      </div>
    </ClickableArea>
  )
}
